/**
 * Created by dx.yang on 2017/2/15.
 */

// const regionCookieName = 'regionKey';
import Vue from 'vue';
import { regionKeyPermissionList } from './constants';
const instanceTypeMap = {
    'I6': Vue.$trans(`IO优化型I6`),
    'GN7I': Vue.$trans(`GPU通用计算型GN7I`),
    // ！！！vGN6  统一key
    'vGN6': Vue.$trans(`GPU虚拟型（vGN6）`), //'GPU虚拟型(vGN6)',
    // 'vGN6-vCS': Vue.$trans(`GPU虚拟型（vGN6-vCS）`), //'GPU虚拟型(vGN6-vCS)',
    // 'vGN6-vPC': Vue.$trans(`GPU虚拟型（vGN6-vPC）`), //'GPU虚拟型(vGN6-vPC)',
    // 'vGN6-vDWS': Vue.$trans(`GPU虚拟型（vGN6-vDWS）`), //'GPU虚拟型(vGN6-vDWS)',
    // 'vGN6-vAPP': Vue.$trans(`GPU虚拟型（vGN6-vAPP）`), //'GPU虚拟型(vGN6-vAPP)',

    // ！！！vGN5  统一key
    'vGN5': Vue.$trans(`GPU虚拟型（vGN5）`), //'GPU虚拟型(vGN5)',
    // 'vGN5-vCS': Vue.$trans(`GPU虚拟型（vGN5-vCS）`), //'GPU虚拟型(vGN5-vCS)',
    // 'vGN5-vPC': Vue.$trans(`GPU虚拟型（vGN5-vPC）`), //'GPU虚拟型(vGN5-vPC)',
    // 'vGN5-vDWS': Vue.$trans(`GPU虚拟型（vGN5-vDWS）`), //'GPU虚拟型(vGN5-vDWS)',
    // 'vGN5-vAPP': Vue.$trans(`GPU虚拟型（vGN5-vAPP）`), //'GPU虚拟型(vGN5-vAPP)',
    'X7': Vue.$trans(`性能保障型X7`),
    'X6S': Vue.$trans(`性能增强型X6S`),
    'X6N': Vue.$trans(`网络增强型X6N`),
    'R6': Vue.$trans(`内存型R6`),
    'HKEC': Vue.$trans(`星河云服务器`),
    'P5V': Vue.$trans(`GPU高效计算型（P5V）`), //GPU高效计算型（P5V）
    'X6E': Vue.$trans(`极速云盘型X6E`), //极速云盘型X6E
    'X6H': Vue.$trans(`性能保障型X6H`), //'性能保障型X6H'
    'GN5I': Vue.$trans(`GPU推理I型（GN5I）`), //'GPU推理I型(GN5I)'
    'S1': Vue.$trans(`标准型S1`), //'标准型S1'
    'S6': Vue.$trans(`标准型S6`), //'标准型S6'
    'X6': Vue.$trans(`性能保障型X6`), //'性能保障型X6'
    'X5': Vue.$trans(`性能保障型X5`), //'性能保障型X5'
    'D6': Vue.$trans(`大数据型D6`), //'大数据型D6'
    'D4': Vue.$trans(`大数据型D4`), //'大数据型D4'
    'FC1': Vue.$trans(`ARM计算型FC1`), //'ARM计算型FC1'
    'AC2': Vue.$trans(`ARM计算型AC2`), //'ARM计算型AC2'
    'GN6I': Vue.$trans(`GPU推理Ⅱ型（GN6I）`), //'推理Ⅱ型(GN6I)',
    'A6': Vue.$trans(`标准型A6`), //'标准型A6'，
    'S4': Vue.$trans(`标准型S4`), //'标准型S4'，
    'C5': Vue.$trans(`计算优化型C5`), //'计算优化型C5'
    'C4': Vue.$trans(`计算优化型C4`), //'计算优化型C4'，
    'I4': Vue.$trans(`IO优化型I4`), //'IO优化型I4',
    'AC1': Vue.$trans(`ARM计算型AC1`), //'ARM计算型AC1'
    'SA1': Vue.$trans(`标准型SA1`), //'标准型SA1',
    'E1': Vue.$trans(`基础型E1`), //'基础型E1',
    'GDVM1': Vue.$trans(`GPU专属型`), //GPU专属宿主机虚机 == GPU专属型
    'DVM2': Vue.$trans(`专属型2.0`), //专属宿主机虚机2.0 == 专属型2.0
    'DVM3': Vue.$trans(`专属型3.0`), //专属宿主机虚机3.0 == 专属型3.0
    'DVM6': Vue.$trans(`专属型6.0`), //专属型6.0,
    'DVM1': Vue.$trans(`专属型`),
    'SN3': Vue.$trans(`标准网络型SN3`), //标准网络型SN3
    'S3': Vue.$trans(`标准型S3`), //'标准型S3'
    // 新机型
    'N3': Vue.$trans(`通用型N3`),
    'P3IN': Vue.$trans(`GPU推理计算型（P3IN）`),
    'X2': Vue.$trans(`性能保障型X2`),
    'N2': Vue.$trans(`通用型N2`),
    //产品要求展示有P4v的文案
    'P4V': Vue.$trans(`GPU通用计算型（P4V）`),
    'P3': Vue.$trans(`GPU通用计算型（P3）`),
    'C3': Vue.$trans(`计算优化型C3`),
    'C2': Vue.$trans(`计算优化型C2`),
    'I3': Vue.$trans(`IO优化型I3`),
    'I2': Vue.$trans(`IO优化型I2`),
    'P3I': Vue.$trans(`GPU推理计算型（P3I）`),
    'C1': Vue.$trans(`计算优化型C1`),
    'I1': Vue.$trans(`IO优化型I1`),
    'N1': Vue.$trans(`通用型N1`),
    'AC4': Vue.$trans(`ARM计算型AC4`),
    'C7': Vue.$trans(`计算优化型C7`),
    'EPCX7': Vue.$trans(`弹性裸金属EPCX7`),
    'EPCX7L': Vue.$trans(`弹性裸金属EPCX7L`),
    'X8': Vue.$trans(`性能保障型X8`),
    'NI6': Vue.$trans(`专属型NI6`),
    'SE9': Vue.$trans(`高效型SE9`),
    'S4E': Vue.$trans(`标准型S4E`),
    'E9': Vue.$trans(`轻量型E9`),
    'AC5': Vue.$trans(`ARM计算型AC5`),
    'X9a': Vue.$trans(`性能保障型X9a`),
}
export default {

    regionList: [],
    regionInfos: {},
    regionKey: KSC_SECNET_CONSOLE.REGION,
    interval: 5000,
    pageSizes: [20, 50, 100],

    vncPermission: true,
    vncPermissionRegion: null,

    //容灾级别映射
    avoidLevelMap: function (key) {
        var obj = {
            host: Vue.$trans(`机器级别`), //'机器级别'
            domain: Vue.$trans(`故障域级别`), //'故障域级别'
        }
        return obj[key] || key;
    },

    //跳转到帮助文档
    openHelpDoc: function (url, enUrl, zindex) {
        let indexEnUrl = '';
        let indexUrl = '';
        if (url) {
            indexUrl = '//docs.ksyun.com/documents/' + url;
        } else {
            return;
        }
        if (enUrl) {
            indexEnUrl = '//endocs.ksyun.com/documents/' + enUrl;
        } else {
            indexEnUrl = indexUrl;
        }
        __ksStorage__.docSet({
            indexUrl: indexUrl,
            indexEnUrl: indexEnUrl,
            zIndex: zindex ? zindex : 1000
        });
    },

    //ssh密钥映射
    sshLevelMap: function (key) {
        var obj = {
            host: Vue.$trans(`机器级别`)
        }
        return obj[key] || key;
    },

    //镜像状态映射
    imageStatusMap: function (key) {
        var map = {
            queued: Vue.$trans(`错误`),
            saving: Vue.$trans(`制作中`), //制作中
            deactived: Vue.$trans(`错误`),
            killed: Vue.$trans(`错误`),
            deleted: Vue.$trans(`错误`),
            pending_delete: Vue.$trans(`错误`),
            error: Vue.$trans(`错误`),
            active: Vue.$trans(`可用`), //可用
            import: Vue.$trans(`导入中`), //'导入中',
            copy: Vue.$trans(`复制中`),//'复制中'
            warming: Vue.$trans(`预热中`), //'预热中'
            pending: Vue.$trans(`导出中`), // 导出中
            processing: Vue.$trans(`导出中`),// 导出中
            canceling: Vue.$trans(`取消导出中`),// 取消导出中
            switching: Vue.$trans(`转换中`) // 类型转换中
        };
        return map[key] || key;
    },
    // 用户信息
    userInfo: '',

    //链路类型映射
    LineNameMapForEip: function (key) {
        var map = {
            '移动': 'YiDong',
            '电信': 'DianXin',
            '联通': 'LianTong',
            '优化BGP': 'zenlayer-guoneiyouhua'
        };
        return map[key] || 'BGP';
    },

    seriesMap: {
        1: Vue.$trans(`系列1`),
        2: Vue.$trans(`系列2`),
        3: Vue.$trans(`系列3`),
        4: Vue.$trans(`系列4`),
        6: Vue.$trans(`系列6`)
    },

    //可用区映射
    azMap: {
        //可用区A 武清
        'cn-qingyangtest-1a': Vue.$trans(`可用区A`),
        'cn-beijing-6a': Vue.$trans(`可用区A`),
        'cn-shanghai-2a': Vue.$trans(`可用区A`),
        'cn-hongkong-2a': Vue.$trans(`可用区A`),
        // 'cn-shanghai-3a': Vue.$trans(`可用区A`),
        'ap-singapore-1a': Vue.$trans(`可用区A`),
        'cn-beijing-1-newa': Vue.$trans(`可用区A`),
        'cn-guangzhou-1a': Vue.$trans(`可用区A`),
        'eu-east-1a': Vue.$trans(`可用区A`),
        'cn-wuhan-1a': Vue.$trans(`可用区A`),
        'cn-taipei-1a': Vue.$trans(`可用区A`),
        'cn-beijing-fin-a': Vue.$trans(`可用区A`),
        'cn-shanghai-fin-a': Vue.$trans(`可用区A`),
        'cn-qingdao-1a': Vue.$trans(`可用区A`),
        'cn-north-1-gov-a': Vue.$trans(`可用区A`),
        'cn-northwest-1a': Vue.$trans(`可用区A`),
        'cn-northwest-2a': Vue.$trans(`可用区A`),
        'cn-north-vip1a': Vue.$trans(`可用区A`),
        'cn-northwest-3a': Vue.$trans(`可用区A`),

        //可用区B 中经
        'cn-qingyangtest-1b': Vue.$trans(`可用区B`),
        'cn-beijing-6b': Vue.$trans(`可用区B`),
        'cn-shanghai-2b': Vue.$trans(`可用区B`),
        // 'cn-shanghai-3b': Vue.$trans(`可用区B`),
        'ap-singapore-1b': Vue.$trans(`可用区B`),
        'cn-beijing-1-newb': Vue.$trans(`可用区B`),
        'cn-guangzhou-1b': Vue.$trans(`可用区B`),
        'eu-east-1b': Vue.$trans(`可用区B`),
        'cn-wuhan-1b': Vue.$trans(`可用区B`),

        //可用区C 万国
        'cn-qingyangtest-1c': Vue.$trans(`可用区C`),
        'cn-beijing-6c': Vue.$trans(`可用区C`),
        'cn-shanghai-2c': Vue.$trans(`可用区C`),
        // 'cn-shanghai-3c': Vue.$trans(`可用区C`),
        'ap-singapore-1c': Vue.$trans(`可用区C`),

        //可用区D 天津智慧港 常熟
        'cn-beijing-6d': Vue.$trans(`可用区D`),
        'cn-shanghai-2d': Vue.$trans(`可用区D`),

        //可用区E 天津逸仙园
        'cn-beijing-6e': Vue.$trans(`可用区E`),

        // 华东2（宁波）可用区A
        'cn-ningbo-1a': Vue.$trans(`可用区A`),

        // 西北4（海东）可用区A
        'cn-northwest-4a': Vue.$trans(`可用区A`),

        'eu-east-1c': Vue.$trans(`可用区C`),
        'eu-east-1d': Vue.$trans(`可用区D`),
        'cn-guangzhou-1c': Vue.$trans(`可用区C`),
    },

    billTypeMap(key) { //计费类型
        var map = {
            // 1: '包年包月',
            // 5: '按日月结',
            // 2: '按小时',
            // 3: '按峰值月结',
            // 80: '按固定带宽',
            // 82: '按量付费'
            '1': Vue.$trans(`包年包月`), //'包年包月',
            '2': Vue.$trans(`按小时`), //'按小时',
            '3': Vue.$trans(`按量付费（月峰值）`), //'按峰值月结',
            '5': Vue.$trans(`按量付费（按日月结）`), //'按日月结',
            '80': Vue.$trans(`按固定带宽`), //按固定带宽
            '82': Vue.$trans(`按量付费`), //按量付费
            '83': Vue.$trans(`地域共享带宽`), //地域共享带宽
            '84': Vue.$trans(`按量付费（按小时月结）`), //按小时月结
            '81': Vue.$trans(`按使用流量`),//'按使用流量',
            '704': Vue.$trans(`按量付费（流量月结）`),//'按量月结',
            '2017': Vue.$trans(`试用`),//试用 前端自己定义的
            '87': Vue.$trans(`按量付费`),//按小时实时结算
            '86': Vue.$trans(`按量付费（流量）`), //'按日用量实时付费',
            '807': Vue.$trans(`增强型95付费`), //'按月增强95峰值付费(月结)',
            '808': Vue.$trans(`第5峰均值付费`), //'按月第5峰均值付费(月结)',
            '809': Vue.$trans(`按量付费（小时用量）`), //'按小时用量实时付费(小时结)',
            '810': Vue.$trans(`竞价型实例`), //'竞价型实例',
        }
        return map[key] || key;
    },

    //主机类型描述
    productTipMap: {
        40: [Vue.$trans(`适合各个行业通用计算需求，如：小型 Web 应用、中小型数据等。`)],
        41: [Vue.$trans(`IO优化型I1实例是高磁盘IO的最佳选择，提供每秒数万次低延迟性随机 操作（IOPS）。`), Vue.$trans(`适合于低延时、I/O密集型应用。`)],
        45: [Vue.$trans(`适合于低延时、I/O密集型应用。`)],
        42: [Vue.$trans(`采用Intel Xeon E5-2680 v3 （Haswell） 处理器，2.5GHz的主频，DDR4内存。`), Vue.$trans(`建议用于游戏服务器、数据库服务器。`)],
        80: [
            Vue.$trans(`采用Intel Xeon E5-2667 v4 （Broadwell） 处理器，3.2GHz的超高主频，DDR4内存。`),
            Vue.$trans(`计算优化型C2实例是高计算性能和高并发读写的应用的最佳选择。`),
            Vue.$trans(`建议用于大型游戏服务器、高性能计算以及其他计算密集型应用。`)
        ],
        78: [
            Vue.$trans(`采用Intel Xeon E5-2690 v4 （Broadwell） 处理器，2.6GHz的高主频，DDR4内存。`),
            Vue.$trans(`IO优化型I2实例是高磁盘IO的最佳选择，提供每秒数万次低延迟性随机 I/O 操作（IOPS）。`),
            Vue.$trans(`适合于低延时、I/O密集型应用，建议用于游戏服务器、数据库服务器。`)
        ],
        43: [Vue.$trans(`存储优化型`)],
        77: [
            Vue.$trans(`GPU通用计算型（P3）实例使用NVIDIA P40 型GPU加速卡单卡拥有12TFlops的单精度浮点运算能力和24GB显存。`),
            Vue.$trans(`可以用于深度学习的训练与推理预测场景，也可以用于其他通用计算加速场景。`)
        ],
        101: [Vue.$trans(`GPU推理计算型P3I实例使用NVIDIA P4 型GPU加速卡，拥有单卡5.6TFlops的单精度浮点运算能力和8GB显存。`), Vue.$trans(`可以用于深度学习的推理场景，被称为推理加速器，也可以结合GRID方案，用于桌面渲染。`)],
        110: [Vue.$trans(`2.7 GHz Intel Xeon® Platinum 8168 处理器，DDR4内存。`), Vue.$trans(`高磁盘 IO 负载，低延迟高吞吐`), Vue.$trans(`适用于MMOGPG、MOBA游戏前端等场景`)],
        111: [Vue.$trans(`3.2 GHz Intel Xeon® Gold 6146  处理器，睿频高达3.6 GHz。DDR4内存。`), Vue.$trans(`高计算性能和高并发读写`), Vue.$trans(`适用于高负载数据库、高负载web等场景`)],
        125: [Vue.$trans(`GPU通用计算型P4V实例使用NVIDIA V100 型GPU计算加速器，拥有单加速器125TFlops的混合精度运算能力和16GB显存。`), Vue.$trans(`可以用于深度学习的训练与推理预测场景，也可以用于其他通用计算加速场景。`)],

    },
    ebsNameMap: {
        'ebs_ssd': Vue.$trans(`云硬盘（SSD）`), //'云硬盘(SSD)',
        'ebs_sata': Vue.$trans(`云硬盘（SATA）`), //'云硬盘(SATA)'
        'system': Vue.$trans(`系统盘`),    //系统盘
        'data': Vue.$trans(`数据盘`),  //数据盘
    },
    // 硬盘状态列表
    diskNameMap: {
        'attached': Vue.$trans(`已挂载`),  //已挂载
        'saving': Vue.$trans(`快照中`),    //快照中
        'restoring': Vue.$trans(`回滚中`), //回滚中

        'system': Vue.$trans(`系统盘`),    //系统盘
        'data': Vue.$trans(`数据盘`),  //数据盘
        'SSD': Vue.$trans(`本地SSD`),    //本地SSD盘
        'SATA': Vue.$trans(`本地SATA`),  //本地SATA盘
        // 老版字段
        'c1': Vue.$trans(`本地SSD`),     //本地SSD盘
        'k1': Vue.$trans(`本地SATA`),    //本地SATA盘
        'c1_en': Vue.$trans(`本地SSD`),     //本地SSD盘
        'root': Vue.$trans(`系统盘`),      //系统盘
        'ephemeral': Vue.$trans(`数据盘`),      //数据盘
        '': ''
    },
    //快照备份方式
    snapBackupMap: {
        'auto': Vue.$trans(`自动`),
        'manual': Vue.$trans(`手动`)
    },
    // 快照类型
    snapTypeMap: {
        'common': Vue.$trans(`普通快照`),  //普通快照
        'local': Vue.$trans(`极速可用快照`)  //极速可用快照
    },
    //快照状态列表
    //以前的逻辑：deleted': Vue.$trans(`已删除`),   //已删除
    snapNameMap: {
        'active': Vue.$trans(`完成`),     //完成
        'restoring': Vue.$trans(`回滚中`),     //回滚中
        'saving': Vue.$trans(`创建中`),    //  创建中
        'unknown': Vue.$trans(`未知错误`),  //未知状态
        'error': Vue.$trans(`错误`),   //错误
        'queued': Vue.$trans(`排队中`), //排队中
        'deleted': Vue.$trans(`主机已删除`), //主机已删除
        'DiskCreating': Vue.$trans(`创建云盘中`)  //创建云盘中
    },

    //系统事件类型
    systemEventType(key) {
        var map = {
            "LocalDiskInstanceReboot": Vue.$trans(`因系统错误实例（本地盘机型）重启`), //因系统错误实例（本地盘机型）重启,
            "InstanceReboot": Vue.$trans(`因系统错误实例（云盘机型）重启`), //因系统错误实例（云盘机型）重启,
            "LocalDiskServerErrorDetected": Vue.$trans(`本地直连盘机型硬件损坏`), //本地直连盘机型硬件损坏,
        }
        return map[key] || key;
    },

    //系统事件状态
    systemEventStatus(key) {
        var map = {
            "Start": Vue.$trans(`事件开始`), //事件开始,
            "Executed": Vue.$trans(`事件完成`), //事件完成,
            "Failed": Vue.$trans(`事件执行失败`), //事件执行失败,
            "TimeScheduled": Vue.$trans(`事件计划时间确定`), //事件计划时间确定
        }
        return map[key] || key;
    },

    projectTrans(projectId, projectName) {
        // if (projectId == 0) {
        //     return Vue.$trans(`默认项目`);
        // }
        return projectName;
    },

    // 主机已上架region列表，用于在页面加载后发一些权限请求时判断缓存的region是否合法
    regionKeyPermissionList,
    //机房映射
    regionMapNew: function (key) {
        var map = {
            // "cn-beijing-6": Vue.$trans(`北京6区（VPC）`),     //北京6区
            // "cn-beijing-5": Vue.$trans(`北京5区`),
            // "cn-shanghai-2": Vue.$trans(`上海2区（VPC）`),    //上海2区
            // "cn-shanghai-3": Vue.$trans(`上海3区（VPC）`),    //上海3区
            // "cn-shanghai-7": Vue.$trans(`上海3区（Basic）`),     //上海3区(Basic)
            // 'cn-hongkong-2': Vue.$trans(`香港2区（VPC）`),    //香港2区(VPC)
            // 'cn-shanghai-1': Vue.$trans(`上海1区`),
            // 'ap-singapore-1': Vue.$trans(`新加坡1区（VPC）`), //新加坡机房
            // 'cn-hongkong-1': Vue.$trans(`香港1区`),
            // 'cn-beijing-3': Vue.$trans(`北京3区`),
            // 'cn-beijing-1': Vue.$trans(`北京1区`),
            // 'cn-beijing-1-new':Vue.$trans(`北京1区（VPC）`),
            // 'cn-guangzhou-1': Vue.$trans(`广州1区（VPC）`),
            // 'eu-east-1': Vue.$trans(`俄罗斯1区（VPC）`),
            // 'cn-wuhan-1': Vue.$trans(`武汉1区（VPC）`),
            // 'cn-taipei-1': Vue.$trans(`台北1区（VPC）`), //台北1区(VPC)
            // 'cn-beijing-fin': Vue.$trans(`北京金融`), //北京金融（万国)
            // 'cn-shanghai-fin': Vue.$trans(`上海金融`), //上海金融（鹏博士)
            // 'cn-qingdao-1': Vue.$trans(`青岛1区（VPC）`), //青岛1区(VPC)
            // 'cn-north-1-gov': Vue.$trans(`华北1（政务）`), //华北1(政务)

            //测试环境机房
            "cn-qingyangtest-1": Vue.$trans(`庆阳1区（测试）`), //庆阳1区（测试）
            // "cn-qingdaodev-1": Vue.$trans(`自用（青岛2）`), //自用(青岛2) 原：青岛研发1区(VPC)
            // "cn-shanghai-3": Vue.$trans(`华东2（上海）`), //华东2(上海) 原：上海3区(VPC)
            // "cn-shanghai-7": Vue.$trans(`上海3区（Basic）`), //上海3区(Basic)

            //线上环境机房
            "cn-beijing-6": Vue.$trans(`华北1（北京）`), //华北1(北京) 原：北京6区(VPC)
            "cn-beijing-fin": Vue.$trans(`华北金融1（北京）`), //华北金融1(北京) 原：北京金融（万国)
            "cn-north-1-gov": Vue.$trans(`华北政务1（北京）`), //华北政务1(北京) 原：华北1(政务)
            "cn-shanghai-2": Vue.$trans(`华东1（上海）`), //华东1(上海) 原：上海2区(VPC)
            "cn-shanghai-fin": Vue.$trans(`华东金融1（上海）`), //华东金融1(上海) 原：上海金融（鹏博士)
            "cn-guangzhou-1": Vue.$trans(`华南1（广州）`), //华南1(广州) 原：广州1区(VPC)
            "cn-hongkong-2": Vue.$trans(`香港`), //香港 原：香港2区(VPC)
            "cn-taipei-1": Vue.$trans(`台北`), //台北 原：台北1区(VPC)
            "cn-qingdao-1": Vue.$trans(`自用（青岛）`), //自用(青岛) 原：青岛1区(VPC)
            "ap-singapore-1": Vue.$trans(`新加坡`), //新加坡 原：新加坡机房
            "eu-east-1": Vue.$trans(`俄罗斯（莫斯科）`), //俄罗斯(莫斯科) 原：俄罗斯1区(VPC)
            "cn-northwest-1": Vue.$trans(`西北1区（庆阳）`),
            'cn-northwest-2': Vue.$trans(`西北2区（自用）`),
            'cn-north-vip1': Vue.$trans(`华北专属1区（天津-小米）`),
            'cn-northwest-3': Vue.$trans(`西北3区（宁夏）`),
            //主机控制台暂未启用
            "cn-central-1": Vue.$trans(`华中1（武汉）`), //华中1(武汉) 原：华中1
            "cn-southwest-1": Vue.$trans(`西南1（重庆）`), //西南1(重庆) 原：西南1
            "ap-Indonesia-1": Vue.$trans(`印度尼西亚（雅加达）`), //印度尼西亚(雅加达) 原：印尼1(VPC)
            "cn-ningbo-1": Vue.$trans(`华东2（宁波）`),
            "cn-northwest-4": Vue.$trans(`西北4（海东）`),
        }
        return map[key] || key;
    },
    //大区默认排序：国内(CN)、亚太(AP)、欧洲(EU)
    areaSort: ['cn', 'ap', 'eu'],
    areaMap(key) { //大区映射
        var map = {
            "all": Vue.$trans(`全部区域`), //"全部区域",
            "cn": Vue.$trans(`国内`), //"国内",
            "ap": Vue.$trans(`亚太`), //'亚太',
            "eu": Vue.$trans(`欧洲`), //'欧洲'
        }
        return map[key] || key;
    },
    //region排序
    regionSortIndex: [
        "cn-qingyangtest-1",
        // "cn-shanghai-3",
        // "cn-shanghai-7",
        // "cn-qingdaodev-1",

        "cn-beijing-6",
        "cn-beijing-fin",
        "cn-north-1-gov",
        'cn-shanghai-2',
        "cn-shanghai-fin",
        "cn-guangzhou-1",
        "cn-northwest-1",
        "cn-northwest-2",
        'cn-hongkong-2',
        "cn-taipei-1",
        "cn-qingdao-1",
        "ap-singapore-1",
        "eu-east-1",
        "cn-north-vip1",
        "cn-northwest-3",

        "cn-central-1",
        "cn-southwest-1",
        "ap-Indonesia-1",
        "cn-ningbo-1",
        "cn-northwest-4",
    ],
    //实例搜索-检索项
    searchCacheDataMap(key) {
        var map = {
            'Instance_name': Vue.$trans(`实例名称`),
            'instance_id': Vue.$trans(`实例ID`),
            'kcs_i18n_438': Vue.$trans(`实例状态`),
            'instance_type': Vue.$trans(`实例类型`),
            'az': Vue.$trans(`可用区`),
            'intranet_ip': Vue.$trans(`私网IP`),
            'global_search': Vue.$trans(`全局搜索`),
            'eip': Vue.$trans(`弹性IP`),
            'nic_id': Vue.$trans(`网卡ID`),
            'subnet_id': Vue.$trans(`子网ID`),
            'security_group_id': Vue.$trans(`安全组ID`),
            'image_id': Vue.$trans(`镜像ID`),
            'billing_model': Vue.$trans(`计费模式`),
            'belong-project': Vue.$trans(`所属项目`),
            'package_spec': Vue.$trans(`套餐规格`)
        }
        return map[key] || key
    },
    //主机状态
    nameMap: {
        '1': Vue.$trans(`包年包月`), //'包年包月',
        '2': Vue.$trans(`按小时`), //'按小时',
        '3': Vue.$trans(`按量付费（月峰值）`), //'按峰值月结',
        '5': Vue.$trans(`按量付费（按日月结）`), //'按日月结',
        '80': Vue.$trans(`按固定带宽`), //按固定带宽
        '82': Vue.$trans(`按量付费`), //按量付费
        '83': Vue.$trans(`地域共享带宽`), //地域共享带宽
        '84': Vue.$trans(`按量付费（按小时月结）`), //按小时月结
        '81': Vue.$trans(`按使用流量`),//'按使用流量',
        '87': Vue.$trans(`按量付费`), //'按小时实时结算'
        '704': Vue.$trans(`按量付费（流量月结）`),//'按量月结',
        '86': Vue.$trans(`按量付费（流量）`), //'按日用量实时付费',
        '807': Vue.$trans(`增强型95付费`), //'按月增强95峰值付费(月结)',
        '808': Vue.$trans(`第5峰均值付费`), //'按月第5峰均值付费(月结)',
        '809': Vue.$trans(`按量付费（小时用量）`), //'按小时用量实时付费(小时结)',
        '810': Vue.$trans(`竞价型实例`), //'竞价型实例',
        '2017': Vue.$trans(`试用`),//试用 前端自己定义的
        'spawning': Vue.$trans(`创建中`), //'创建中',
        'building': Vue.$trans(`创建中`), //'创建中',
        'error': Vue.$trans(`失败`), //'失败',
        'active': Vue.$trans(`运行中`), //'运行中',
        'stopping': Vue.$trans(`关闭中`), //'关闭中',
        'stopped': Vue.$trans(`已关闭`), //'已关闭',
        'starting': Vue.$trans(`启动中`), //'启动中',
        'rebooting': Vue.$trans(`重启中`), //'重启中',
        'deleted': Vue.$trans(`已删除`), //'已删除',
        'resize_prep': Vue.$trans(`调整配置中`), //调整配置中， 原'升级中',
        'deleting': Vue.$trans(`删除中`), //'删除中',
        'rebuilding': Vue.$trans(`重装中`), //'重装中',
        'soft-delete': Vue.$trans(`延迟删除`), //'延迟删除',
        'powering-off': Vue.$trans(`强制关机中`),//'强制关机中', //Vue.$trans(`删除中`), //'删除中',
        'powering-on': Vue.$trans(`启动中`), //'启动中',
        'paused': Vue.$trans(`暂停`), //'暂停',
        'suspended': Vue.$trans(`挂起`), //'挂起',
        'attaching_interface': Vue.$trans(`挂载辅网卡中`), //'挂载辅网卡中',
        'recycling': Vue.$trans(`已回收`), //已回收
        'attaching_key': Vue.$trans(`密钥绑定中`), //密钥绑定中
        'detaching_key': Vue.$trans(`密钥解绑中`), //密钥解绑中
        'migrating': Vue.$trans(`迁移中`), //'迁移中',

        'net_card_loading': Vue.$trans(`网卡挂载中`),
        'net_card_unloading': Vue.$trans(`网卡卸载中`),


        /*** basic机房独有状态 start ***/
        'restarting': Vue.$trans(`重启中`), //'重启中',
        'backuping': Vue.$trans(`镜像中`), //'镜像中',
        'resizing': Vue.$trans(`调整配置中`), // 调整配置中，原'升级中',
        'overriding': Vue.$trans(`重装中`), //'重装中',
        'invalid': Vue.$trans(`已停用`), //'已停用',
        'binded': Vue.$trans(`已绑定`), //'已绑定',
        'unbind': Vue.$trans(`未绑定`), //'未绑定',
        'toexpire': Vue.$trans(`即将过期`), //'即将过期',
        'csresize-error': Vue.$trans(`升级失败`), //'升级失败',
        /*** basic机房独有状态 end ***/
        'updating_hostname': Vue.$trans(`改名中`), //改名中
        'updating_password': Vue.$trans(`改密中`), //'改密中',
        'unpausing': Vue.$trans(`取消暂停中`), //'取消暂停中',
        'suspending': Vue.$trans(`挂起中`), //'挂起中',
        'resuming': Vue.$trans(`挂起恢复中`), //'挂起恢复中',
        'resized': Vue.$trans(`离迁完成`), //'离迁完成',
        'scheduling': Vue.$trans(`创建中`), //'创建中',
        'networking': Vue.$trans(`创建中`), //'创建中',
        'block_device_mapping': Vue.$trans(`创建中`), //'创建中',
        'image_snapshot': Vue.$trans(`创建镜像中`), //'创建镜像中',
        'image_backup': Vue.$trans(`备份创建中`), //'备份创建中',
        'resize_migrating': Vue.$trans(`离线迁移中`), //'离线迁移中',
        'resize_migrated': Vue.$trans(`已离线迁移`), //'已离线迁移',
        'resize_finish': Vue.$trans(`离线迁移完成`), //'离线迁移完成',
        'resize_reverting': Vue.$trans(`离线迁移回退中`), //'离线迁移回退中',
        'resize_confirming': Vue.$trans(`离线迁移确认中`), //'离线迁移确认中',
        // 'migrating': Vue.$trans(`在线迁移中`), //'在线迁移中',
        'rebooting_hard': Vue.$trans(`强制重启中`), //'强制重启中',
        'pausing': Vue.$trans(`暂停只能够`), //'暂停只能够',
        'rebuild_block_device_mapping': Vue.$trans(`重装块设备映射中`), //'重装块设备映射中',
        'rebuild_spawning': Vue.$trans(`重装主机生成中`),  //'重装主机生成中',
        'epheme_restoring': Vue.$trans(`数据盘回滚中`), //'数据盘回滚中',
        'epheme_saving': Vue.$trans(`数据盘快照中`), //'数据盘快照中',

        'image_auto_snapshotting': Vue.$trans(`自动快照中`), //自动快照中
        'image_auto_backuping': Vue.$trans(`自动备份中`), //自动备份中
        'rescuing': Vue.$trans(`故障恢复中`), //故障恢复中
        'unrescuing': Vue.$trans(`故障恢复状态解除中`), //故障恢复状态解除中
        'resource_checking': Vue.$trans(`检查资源中`), //检查资源中
        'resource_check': Vue.$trans(`资源检查中`), //资源检查中
        'resource_checked': Vue.$trans(`主机资源检查后，锁定主机`), //主机资源检查后，锁定主机
        'resource_check_failed': Vue.$trans(`主机检查失败标志`), //主机检查失败标志
        'resource_del': Vue.$trans(`主机检查后，被删除`), //主机检查后，被删除
        'evacuate': Vue.$trans(`已疏散迁移`), //已疏散迁移
        'waiting_volume_attached': Vue.$trans(`创建中`), //'创建中',
        'migrate': Vue.$trans(`迁移中`), //"迁移中",

        'ephemeral_disk_backup_queued': Vue.$trans(`快照创建中`), //快照创建中
        'ephemeral_disk_backuping': Vue.$trans(`快照创建中`), //快照创建中
        'ephemeral_disk_restore_queued': Vue.$trans(`快照回滚中`), //快照回滚中
        'ephemeral_disk_restoring': Vue.$trans(`快照回滚中`), //快照回滚中
        'extending_volume': Vue.$trans(`硬盘扩容中`), //硬盘扩容中
        // 在线升配新加的主机状态字段
        'pre_migrating': Vue.$trans(`调整配置中`), //调整配置中，原调整配置准备中
        'pre_migrating_error': Vue.$trans(`调整配置失败`),  //预迁移失败
        'migrating': Vue.$trans(`调整配置中`), //调整配置中 即在线升配中
        'migrating_error': Vue.$trans(`调整配置失败`), //调整配置失败 即在线升配失败 手动恢复主机状态
        'migrating_success': Vue.$trans(`调整配置成功`), //调整配置成功 即在线升配成功 需要重启服务器生效

        'migrating_error_off_line': Vue.$trans(`调整配置失败`), //调整配置失败 即离线升配失败 手动恢复主机状态
        'migrating_success_off_line': Vue.$trans(`调整配置成功`), //调整配置成功 即离线升配成功 需要启动服务器生效
        'resize_error_local': Vue.$trans(`调整配置失败`), //调整配置失败 即本地升配失败 手动恢复主机状态
        'resize_success_local': Vue.$trans(`调整配置成功`), //调整配置成功 即本地升配成功 需要启动服务器生效

        'attach_key_pair_failed': Vue.$trans(`绑定密钥失败`), //绑定密钥失败 手动恢复主机状态
        'detach_key_pair_failed': Vue.$trans(`解绑密钥失败`), //解绑密钥失败 手动恢复主机状态

        //加入容灾组映射
        'drg_migrating_error': Vue.$trans(`加入容灾组失败`),//加入容灾分组失败
        'drg_migrating': Vue.$trans(`加入容灾组中`), //加入容灾分组中
        // 'cold_restart': Vue.$trans(`冷重启中`) //冷重启中

        //主机状态--即将过期
        'aboutToExpired': '即将过期',

        //OP迁移中云主机控制台展示“迁移中”
        'migrating_op': Vue.$trans(`迁移中`), //'迁移中'

        //关机不收费
        'power_on_error': Vue.$trans(`开机失败`), //开机失败

        // 变更实例类型
        'cross_queue': Vue.$trans(`排队中`), //排队中（跨实例迁移排队中）
        'cross_migrating': Vue.$trans(`配置变更中`), //配置变更中（跨实例迁移中）
        'cross_finish': Vue.$trans(`变更配置完成`), //变更配置完成（跨实例迁移完成）
        'cross_error': Vue.$trans(`变更配置失败`), //变更配置失败（跨实例迁移失败）
        //预迁移
        'reserve_pre_migrate_queue': Vue.$trans(`预迁移排队中`), // 预迁移排队中
        'reserve_pre_migrating': Vue.$trans(`预迁移中`),   // 预迁移中
        'reserve_pre_migrated': Vue.$trans(`待变更`),   // 待变更
        'reserve_pre_migrate_canceling': Vue.$trans(`取消预迁移中`), // 取消预迁移中

        // 挂载系统盘
        'without_sys_disk': Vue.$trans(`无系统盘`), // 无系统盘
        'attaching_sys_disk': Vue.$trans(`系统盘绑定中`), //系统盘绑定中
        'detaching_sys_disk': Vue.$trans(`系统盘解绑中`), //系统盘解绑中

        'update_password_failed': Vue.$trans(`重置密码失败`)
    },

    //专属宿主机
    exclusiveMap: function (key) {
        var map = {
            87: Vue.$trans(`通用型DN1`), //'通用型DN1',
            88: Vue.$trans(`内存型DR1`), //'内存型DR1',
            102: Vue.$trans(`计算型DC1`), //计算型DC1
            141: Vue.$trans(`通用型DN2`),//'通用型DN2'
            183: Vue.$trans(`标准型DS2`),//标准型DS2
            184: Vue.$trans(`计算型DC2`),//计算型DC2
            189: Vue.$trans(`标准型DS3`), //标准型DS3
            191: Vue.$trans(`内存型DR3`), //内存型DR3
            602: Vue.$trans(`ARM异构计算型AG1`), //ARM异构计算型AG1
            640: Vue.$trans(`标准型DS6`), //标准型DS6

            'DN1': Vue.$trans(`通用型DN1`), //'通用型DN1',
            'DR1': Vue.$trans(`内存型DR1`), //'内存型DR1',
            'DC1': Vue.$trans(`计算型DC1`), //计算型DC1
            'DN2': Vue.$trans(`通用型DN2`), //'通用型DN2'
            'DS2': Vue.$trans(`标准型DS2`), //标准型DS2
            'DC2': Vue.$trans(`计算型DC2`), //计算型DC2
            'DS3': Vue.$trans(`标准型DS3`), //标准型DS3
            'DR3': Vue.$trans(`内存型DR3`), //内存型DR3
            'AG1': Vue.$trans(`ARM异构计算型AG1`), //ARM异构计算型AG1
            'DS6': Vue.$trans(`标准型DS6`), //标准型DS6

            1: Vue.$trans(`创建中`), //'创建中',
            2: Vue.$trans(`运行中`), //'运行中',
            // 4: Vue.$trans(`已到期`),  //'已到期',
            // 5: Vue.$trans(`已到期`),  //'已到期'
            // 10: Vue.$trans(`已欠费`),  //'已欠费'
            // 11: Vue.$trans(`已欠费`),  //'已欠费'
            4: Vue.$trans(`已过期`), //'已过期--到期关停',
            5: Vue.$trans(`已回收`), //'已回收--到期回收'
            6: Vue.$trans(`已退订`), //'已退订'
            8: Vue.$trans(`已欠费`), //'已欠费'
            9: Vue.$trans(`欠费回收`), //'欠费回收'
            10: Vue.$trans(`一键关停`), //'一键关停'
            11: Vue.$trans(`一键回收`), //'一键回收'
            12: Vue.$trans(`退订中`), //'退订中'
        }
        return map[key] || key;
    },

    //专属宿主机-机型描述
    exclusiveDec: function (key) {
        var map = {
            87: "", //'通用型DN1',
            88: Vue.$trans(`2.60GHz Intel®Xeon®E5-2690 v4 处理器，DDR4内存`), //'内存型DR1',
            102: Vue.$trans(`2.60GHz Intel®Xeon®E5-2690 v4 处理器，DDR4内存`), //计算型DC1
            141: Vue.$trans(`2.70GHz Intel® Xeon® Platinum 8168 处理器，DDR4内存`), //'通用型DN2'
            183: Vue.$trans(`2.60GHz Intel®Xeon®Gold 6132 处理器，DDR4内存`), //标准型DS2
            184: Vue.$trans(`2.60GHz Intel®Xeon®E5-2690 v4 处理器，DDR4内存`), //计算型DC2
            189: Vue.$trans(`2.60GHz Intel®Xeon®Gold 6240 处理器，最新六通道DDR4`), //标准型DS3
            191: Vue.$trans(`2.70GHz Intel® Xeon® Platinum 8168 处理器，DDR4内存`), //内存型DR3
            602: "", //ARM异构计算型AG1
            640: Vue.$trans(`2.60GHz Intel®Xeon®Platinum 8358P（Icelake） 处理器，最新八通道DDR4`), //标准型DS6
        }
        return map[key] || key;
    },

    //预留实例包 实例状态
    // reservedStatusMap: function (key) {
    //     var map = {
    //         1: Vue.$trans(`开通中`), //开通中
    //         2: Vue.$trans(`已开通`), //已开通
    //         3: Vue.$trans(`开通失败`), //开通失败
    //         4: Vue.$trans(`已过期`), //已过期
    //         5: Vue.$trans(`已回收`), //已回收
    //         6: Vue.$trans(`已退订`), //已退订
    //         11: Vue.$trans(`一键回收`), //一键回收
    //         9: Vue.$trans(`欠费回收`), //欠费回收
    //         8: Vue.$trans(`已欠费`), //已欠费
    //         10: Vue.$trans(`一键关停`), //一键关停
    //     }
    //     return map[key] || key;
    // },

    //预留实例包 抵扣状态
    // reservedDeductStatusMap: function (key) {
    //     var map = {
    //         1: Vue.$trans(`未开始`), //未开始
    //         2: Vue.$trans(`可抵扣`), //原“抵扣中”改为“可抵扣”
    //         3: Vue.$trans(`失效`), //失效
    //         4: Vue.$trans(`暂停`), //暂停
    //     }
    //     return map[key] || key;
    // },

    bwsRegionList: [
        'cn-qingyangtest-1',
        'cn-beijing-6',
        'cn-shanghai-2',
        'cn-beijing-1',
        'cn-beijing-1-new',
        'cn-shanghai-1',
        // 'cn-shanghai-3',
        // 'cn-shanghai-7',
        'cn-hongkong-2',
        'cn-guangzhou-1',
        'cn-northwest-1',
        'cn-northwest-2',
        'eu-east-1',
        'cn-north-vip1',
        'cn-northwest-3',
        'cn-northwest-4', //西北4（海东）
        'cn-ningbo-1', // 华东2（宁波）
    ],
    renewMap: {
        1: Vue.$trans(`续费`),　//续费
        2: Vue.$trans(`转正`)　//转正
    },

    //自动快照重复时间
    weekMap: function (key) {
        let arr = _.map(key, (item) => {
            switch (item) {
                case ("1"): return Vue.$trans(`周一`); //"周一";
                case ("2"): return Vue.$trans(`周二`); //"周二";
                case ("3"): return Vue.$trans(`周三`); //"周三";
                case ("4"): return Vue.$trans(`周四`); //"周四";
                case ("5"): return Vue.$trans(`周五`); //"周五";
                case ("6"): return Vue.$trans(`周六`); //"周六";
                case ("7"): return Vue.$trans(`周日`); //"周日";
                default: return ""
            }

        });
        return arr.join('/');
    },

    productTypeMap: {
        40: Vue.$trans(`通用型N1`),//'通用型N1',
        41: Vue.$trans(`IO优化型I1`),//'IO优化型I1',
        137: Vue.$trans(`通用型N2`), //'通用型N2',
        151: Vue.$trans(`通用型N3`), //'通用型N2',
        42: Vue.$trans(`计算优化型C1`),//'计算优化型C1',
        138: Vue.$trans(`性能保障型X2`), //'性能保障型X2',
        45: 'IO优化型I1（联网增强）',
        46: '计算优化型C1（联网增强）',
        78: Vue.$trans(`IO优化型I2`), //'IO优化型I2',
        110: Vue.$trans(`IO优化型I3`), //'IO优化型I3',
        79: 'IO优化型I2（联网增强）',
        111: Vue.$trans(`计算优化型C3`),//'计算优化型C3',
        152: Vue.$trans(`标准型S3`), //'标准型S3',
        101: Vue.$trans(`GPU推理计算型（P3I）`),//'GPU推理计算型(P3I)',
        77: Vue.$trans(`GPU通用计算型（P3）`),//'GPU通用计算型(P3)',
        125: Vue.$trans(`GPU通用计算型（P4V）`),//'GPU通用计算型(P4V)',
        126: Vue.$trans(`GPU图形计算型（G1）`),//'GPU图形计算型(G1)',
        142: Vue.$trans(`GPU推理计算型（P3IN）`),//'GPU推理计算型(P3IN)'
        187: Vue.$trans(`标准网络型SN3`), //标准网络型SN3
        192: Vue.$trans(`容器实例型`), //'容器实例型',
        198: Vue.$trans(`标准型SA1`), //'标准型SA1',
        96: Vue.$trans(`专属型`), //专属宿主机虚机
        143: Vue.$trans(`专属型2.0`), //专属宿主机虚机2.0
        517: Vue.$trans(`专属型3.0`), //专属型3.0,
        603: Vue.$trans(`GPU专属型`), //GPU专属型,
        642: Vue.$trans(`专属型6.0`), //专属型6.0,
        305: Vue.$trans(`ARM计算型AC1`), //'ARM计算型AC1'
        303: Vue.$trans(`基础型E1`), //'基础型E1',
        321: Vue.$trans(`GPU虚拟型（vGN5）`), //'GPU虚拟型(vGN5)',
        377: Vue.$trans(`GPU虚拟型（vGN6）`), //'GPU虚拟型(vGN6)',
        326: Vue.$trans(`GPU推理Ⅱ型（GN6I）`), //'推理Ⅱ型(GN6I)',
        353: Vue.$trans(`GPU通用计算型（P3L）`), //'GPU通用计算型(P3L)',
        347: Vue.$trans(`计算优化型C4`), //'计算优化型C4'，
        548: Vue.$trans(`计算优化型C5`), //'计算优化型C5'
        348: Vue.$trans(`标准型S4`), //'标准型S4'，
        652: Vue.$trans(`标准型A6`), //'标准型A6'，
        357: Vue.$trans(`IO优化型I4`), //'IO优化型I4',
        388: Vue.$trans(`ARM计算型AC2`), //'ARM计算型AC2'
        430: Vue.$trans(`大数据型D4`), //'大数据型D4'
        641: Vue.$trans(`大数据型D6`), //'大数据型D6'
        401: Vue.$trans(`ARM计算型FC1`), //'ARM计算型FC1'
        508: Vue.$trans(`性能保障型X5`), //'性能保障型X5'
        547: Vue.$trans(`性能保障型X6`), //'性能保障型X6'
        595: Vue.$trans(`标准型S6`), //'标准型S6'
        298: Vue.$trans(`标准型S1`), //'标准型S1'
        597: Vue.$trans(`GPU推理I型（GN5I）`), //'GPU推理I型(GN5I)'
        627: Vue.$trans(`性能保障型X6H`), //'性能保障型X6H'
        628: Vue.$trans(`极速云盘型X6E`), //极速云盘型X6E
        661: Vue.$trans(`GPU高效计算型（P5V）`), //GPU高效计算型（P5V）
        656: Vue.$trans(`星河云服务器`),
        647: Vue.$trans(`内存型R6`),
        651: Vue.$trans(`网络增强型X6N`),
        668: Vue.$trans(`IO优化型I6`),
        650: Vue.$trans(`性能增强型X6S`),
        687: Vue.$trans(`性能保障型X7`),
        690: Vue.$trans(`GPU通用计算型GN7I`),
        710: Vue.$trans(`ARM计算型AC4`),
        712: Vue.$trans(`计算优化型C7`),
        729: Vue.$trans(`性能保障型X8`),
        731: Vue.$trans(`专属型NI6`),
        162006: Vue.$trans(`高效型SE9`),
        498: Vue.$trans(`标准型S4E`),
        1144: Vue.$trans(`轻量型E9`),
        1142: Vue.$trans(`ARM计算型AC5`),
        1157: Vue.$trans(`性能保障型X9a`),
    },
    //自动快照时间
    clockMap: function (key) {
        let clockarr = _.map(key, (item) => {
            item = item + '';
            switch (item) {
                case ("0"): return "0:00";
                case ("1"): return "1:00";
                case ("2"): return "2:00";
                case ("3"): return "3:00";
                case ("4"): return "4:00";
                case ("5"): return "5:00";
                case ("6"): return "6:00";
                case ("7"): return "7:00";
                case ("8"): return "8:00";
                case ("9"): return "9:00";
                case ("10"): return "10:00";
                case ("11"): return "11:00";
                case ("12"): return "12:00";
                case ("13"): return "13:00";
                case ("14"): return "14:00";
                case ("15"): return "15:00";
                case ("16"): return "16:00";
                case ("17"): return "17:00";
                case ("18"): return "18:00";
                case ("19"): return "19:00";
                case ("20"): return "20:00";
                case ("21"): return "21:00";
                case ("22"): return "22:00";
                case ("23"): return "23:00";
                default: return "";
            }
        })
        return clockarr.join('/');
    },
    systemDiskType: {
        'SSD2.0': Vue.$trans(`云硬盘2.0（SSD）`),
        'SATA2.0': Vue.$trans(`云硬盘2.0（SATA）`),
        'SSD3.0': Vue.$trans(`云硬盘3.0（SSD）`),
        'EHDD': Vue.$trans(`高效云盘`),
        'ESSD': Vue.$trans(`ESSD云硬盘`), // ESSD云盘 
    },

    hardDiskTypes: {
        3: 'SSD2.0',
        4: 'SATA2.0',
        132: 'SSD3.0',
        133: 'SATA3.0',
        197: 'EHDD',
        501: 'ESSD_PL3',
        564: 'ESSD_PL2',
        565: 'ESSD_PL1',
        566: 'ESSD_PL0',
    },

    //整机镜像支持机房
    machineMirrorRegionList: [
        'cn-qingyangtest-1', //庆阳1区（测试）
        // 'cn-shanghai-3', //上海3区 用于测试环境
        'cn-beijing-6', //北京6区
        'cn-shanghai-2', //上海2区
        'cn-guangzhou-1', //广州1区
        'cn-northwest-1', //西北1区(庆阳)
        'cn-northwest-2', //西北2区(自用)
        'eu-east-1', //俄罗斯1区(VPC)
        'cn-north-vip1', //华北专属1区（天津-小米）
        'cn-northwest-3', //西北2区(宁夏)
        'ap-singapore-1', //新加坡机房
        'cn-taipei-1', //台北1区(VPC)
        'cn-beijing-fin', //北京金融
        'cn-shanghai-fin', //上海金融
        'cn-qingdao-1', //青岛1区(VPC)
        'cn-north-1-gov', //华北1(政务)
        'cn-hongkong-2', //香港2区(VPC)
        'cn-northwest-4', //西北4（海东）
        'cn-ningbo-1', // 华东2（宁波）
    ],

    //弹性网卡四期支持机房
    eip4SupportRegionList: [
        'cn-qingyangtest-1', //庆阳1区（测试）
        // 'cn-shanghai-3', //上海3区 用于测试环境
        // "cn-shanghai-7",
        // "cn-qingdaodev-1",

        'cn-beijing-6', //北京6区
        'cn-shanghai-2', //上海2区
        'cn-guangzhou-1', //广州1区
        'cn-northwest-1', //西北1区(庆阳)
        'cn-northwest-2', //西北2区(自用)
        'eu-east-1', //俄罗斯1区(VPC)
        'ap-singapore-1', //新加坡机房
        'cn-taipei-1', //台北1区(VPC)
        'cn-beijing-fin', //北京金融
        'cn-shanghai-fin', //上海金融
        'cn-qingdao-1', //青岛1区(VPC)
        'cn-north-1-gov', //华北1(政务)
        'cn-hongkong-2', //香港2区(VPC)
        'cn-north-vip1', //华北专属1区（天津-小米）
        'cn-northwest-3', //西北2区(宁夏)
        'cn-northwest-4', //西北4（海东）
        'cn-ningbo-1', // 华东2（宁波）
    ],

    //实例列表 类型 下拉列表选项
    instanceTypeMap,
    //实例列表 列表展示
    listInstanceTypeMap: {
        ...instanceTypeMap,
        'M1': Vue.$trans(`大米主机`),
        'GA1': Vue.$trans(`GPU图形计算型`),//'GPU图形计算型',
        'K1': Vue.$trans(`容器实例型`), //'容器实例型',
        'vGN5-vCS': Vue.$trans(`GPU虚拟型（vGN5-vCS）`), //'GPU虚拟型(vGN5-vCS)',
        'vGN5-vPC': Vue.$trans(`GPU虚拟型（vGN5-vPC）`), //'GPU虚拟型(vGN5-vPC)',
        'vGN5-vDWS': Vue.$trans(`GPU虚拟型（vGN5-vDWS）`), //'GPU虚拟型(vGN5-vDWS)',
        'vGN5-vAPP': Vue.$trans(`GPU虚拟型（vGN5-vAPP）`), //'GPU虚拟型(vGN5-vAPP)',
        'GNP3L': Vue.$trans(`GPU通用计算型（P3L）`), //'GPU通用计算型(P3L)',
        'vGN6-vCS': Vue.$trans(`GPU虚拟型（vGN6-vCS）`), //'GPU虚拟型(vGN6-vCS)',
        'vGN6-vPC': Vue.$trans(`GPU虚拟型（vGN6-vPC）`), //'GPU虚拟型(vGN6-vPC)',
        'vGN6-vDWS': Vue.$trans(`GPU虚拟型（vGN6-vDWS）`), //'GPU虚拟型(vGN6-vDWS)',
        'vGN6-vAPP': Vue.$trans(`GPU虚拟型（vGN6-vAPP）`), //'GPU虚拟型(vGN6-vAPP)',
    },
    //ebs的云盘详情需要关闭左侧列表，控制左侧列表开关
    supportEbsIframe: false

}
